var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tooltip__container"},[_vm._t("default"),_c('div',{staticClass:"tip"},[_c('p',[_vm._v(_vm._s(_vm.text))])])],2)}
var staticRenderFns = []

export { render, staticRenderFns }